import {COIMessage} from './coi-message';
import {EnrollmentList} from './business/enrollment-list';

export interface Equipment extends COIMessage {
  equipment_id: number;
  account_id: number;
  equipment_name: string;
  equipment_meter: string;
  equipment_serial_number: string;
  equipment_model_number: string;
  equipment_capacity: number;
  equipment_type: EquipmentTypeWithCategory;
  equipment_quantity_of_units: number;
  equipment_nameplate_capacity: number;
  equipment_efficiency_rating?: string;
  equipment_power_factor?: string;
  equipment_operation: string;
  equipment_participation_in_program: string;
  equipment_manufacture: string;
  equipment_installed_date?: any;
  equipment_manufactured_date?: any;
  equipment_desc?: string;
  equipment_model_release_date?: any;
  originalIndex?: number;
  latest_asset: boolean;
  is_new_asset?: boolean;
  is_deletable?: boolean;
  is_editable?: boolean;
  enrollmentList?: EnrollmentList;
  equipmentImageList?: EquipmentImage[];
  totalCapacity?: number;
}

export interface EquipmentImage {
  equipment_id: number;
  equipment_image_caption: string;
  equipment_image_id: number;
  signed_link: string;
}

export const Operations = {
  'normal_use': 'Normal Use',
  'continuous_running': 'Continuous Running',
  'standby': 'Standby',
  'normal_closed_open': 'Normal Closed/Open',
  'intermittent': 'Intermittent'
};

export const ParticipationInProgram = {
  'manual': 'Manual',
  'automatic': 'Automatic'
};

export interface EquipmentCategory extends COIMessage {
  equipment_category_id: number;
  equipment_category_name: string;
  types: EquipmentType[];
}

export interface EquipmentType extends COIMessage {
  equipment_type_id: number;
  equipment_type_name: string;
  equipment_type_unit: string;
}

export interface EquipmentTypeWithCategory extends COIMessage {
  equipment_type_id: number;
  equipment_type_name: string;
  equipment_type_unit: string;
  equipmentCategory: EquipmentCategory;
}
